import { ContractFilters } from "../../type/Address.type";
import { Request } from "../Request";
import instance from "../AppRequest";
import { AxiosResponse } from "axios";
import { ApiUrls } from "../../constants/services";


class ContractFilterService {
    private axiosService: Request;

    constructor(request: any) {
        this.axiosService = request;
    }

    public async getAddressFilters(contractId: string): Promise<AxiosResponse<ContractFilters> | null> {
        return this.axiosService
            .get(ApiUrls.CONTRACT_ADDRESS_FILTERS.replace(':contractId', contractId))
            .catch(() => { console.log(`No address filter for this contract '${contractId}'`); return null })
            .finally(() => null)
    }
}

export default new ContractFilterService(instance)
